import React from "react";
import { connect } from "react-redux";
import { setDashboardParams } from "../../../../store/actions";

class DashboardRouteSelector extends React.Component {
  handleRouteSelection = (ev) => {
    ev.preventDefault();
    this.props.setSelectedRoute(+ev.target.value);
  };

  isSelected = (val) => {
    return this.props.selectedRoute === val;
  };

  render() {
    return (
      <div>
        <div className="box-select-wrapper">
          <select
            className="box-selector"
            onChange={this.handleRouteSelection}
            disabled={this.props.isloading === true}
            value={this.props.selectedRoute}
          >
            <option key="0" value={0}>
              All Routes
            </option>
            {this.props.routes.map((route) => {
              const toPass = { style: { color: route.hex_color } };
              return (
                <option key={route.id} value={route.id} {...toPass}>
                  {route.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  routes:
    state.aggregates.routes && Array.isArray(state.aggregates.routes.rows)
      ? state.aggregates.routes.rows
      : [],
  selectedRoute: state.dashboardParams.selectedRoute,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedRoute: (id) => dispatch(setDashboardParams({ selectedRoute: id })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardRouteSelector);
